// extracted by mini-css-extract-plugin
export default {"btn":"styles_btn__OqNTe","children":"styles_children__xrFFB","active":"styles_active__fU1IC","disabled":"styles_disabled__GZrd+"};